module.exports = __webpack_public_path__ + "img/persil_plat.feb86883.jpg";